import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import ItemSmall from './ItemSmall';
import ManageCategory from './ManageCategory';
import ManageProduct from './ManageProduct';
import ReactModal from './ReactModal';
import { COLORS } from '../utils/colors';

const SmallListMenu = (props) => {
  const { products, categories, visible } = props;
  const [categoryModalIsOpen, setCategoryModalIsOpen] = useState(false);
  const [productModalIsOpen, setProductModalIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const handleCategoryClick = (category) => {
    setActiveItem(category);
    setCategoryModalIsOpen(true);
  };

  const handleProductClick = (product) => {
    setActiveItem(product);
    setProductModalIsOpen(true);
  };

  if (!visible) return null;

  return (
    <div>
      {categories.length > 0 && (
        <>
          <Grid item xs={12}>
            <p
              style={{
                fontSize: '0.8rem',
                fontWeight: 'bold',
                color: COLORS.INFO,
                textAlign: 'center',
                marginBottom: '32px',
              }}
            >
              CATEGORIES
            </p>
          </Grid>
          <Grid container spacing={2} item xs={12}>
            {categories.map((category) => {
              return (
                <Grid key={category.id} item xs={12} sm={12} md={6}>
                  <ItemSmall
                    item={category}
                    position={Math.abs(category.position)}
                    action={() => handleCategoryClick(category)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
      {products.length > 0 && (
        <>
          <Grid item xs={12}>
            <p
              style={{
                fontSize: '0.8rem',
                fontWeight: 'bold',
                color: COLORS.INFO,
                textAlign: 'center',
                margin: '32px 0',
              }}
            >
              PRODUCTS
            </p>
          </Grid>
          <Grid container spacing={2} item xs={12}>
            {products.map((product) => {
              return (
                <Grid key={product.id} item xs={12} sm={12} md={6}>
                  <ItemSmall
                    item={product}
                    position={product.position}
                    action={() => handleProductClick(product)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
      {products.length === 0 && categories.length === 0 && (
        <Grid item xs={12}>
          <p
            style={{
              fontSize: '0.8rem',
              fontWeight: 'bold',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '32px',
            }}
          >
            Nothing found!
          </p>
        </Grid>
      )}

      {categoryModalIsOpen && (
        <ReactModal modalIsOpen={categoryModalIsOpen} setIsOpen={setCategoryModalIsOpen}>
          <ManageCategory categoryId={activeItem.id} serviceId={activeItem.serviceId} close={() => setCategoryModalIsOpen(false)} />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}

      {productModalIsOpen && (
        <ReactModal modalIsOpen={productModalIsOpen} setIsOpen={setProductModalIsOpen}>
          <ManageProduct
            productId={activeItem.id}
            categoryId={activeItem.category_id}
            close={() => setProductModalIsOpen(false)}
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
    </div>
  );
};

export default SmallListMenu;
